import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Container } from '../styledComponents/noCamDataComponents/container';
import { NoCamWidgetImage } from './noCamWidgetImage.jsx';
import { NoCamTextContainer } from '../styledComponents/noCamDataComponents/noCamTextContainer';
import { withScreenSize } from '../../common/utilities/withScreenSize.jsx';

@withScreenSize
export class NoWidgetCamData extends PureComponent {

    static displayName = 'NoWidgetCamData';

    static propTypes = {
        isMobile: PropTypes.bool,
        isTablet: PropTypes.bool,
        isDesktop: PropTypes.bool,
        isWeatherCamWidget: PropTypes.bool,
        noAvailableCam: PropTypes.bool
    };


    render() {

        const { isMobile, isDesktop, isTablet, noAvailableCam, isWeatherCamWidget } = this.props;

        return (
            <Container >
                <NoCamWidgetImage isMobile={isMobile} isTablet={isTablet} isDesktop={isDesktop} />
                <NoCamTextContainer>
                    { !noAvailableCam ? `${isWeatherCamWidget ? 'Weather' : 'Traffic'} Cam not available at this time` : `No ${isWeatherCamWidget ? 'Weather' : 'Traffic'} Cams available in this region`}
                </NoCamTextContainer>
            </Container>
        );

    }
}
